/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Levels_LeadInputs */

const en_for_whom_levels_lead = /** @type {(inputs: For_Whom_Levels_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At every level.`)
};

const pl_for_whom_levels_lead = /** @type {(inputs: For_Whom_Levels_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na każdym poziomie.`)
};

/**
* | output |
* | --- |
* | "At every level." |
*
* @param {For_Whom_Levels_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_levels_lead = /** @type {((inputs?: For_Whom_Levels_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Levels_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_levels_lead(inputs)
	return en_for_whom_levels_lead(inputs)
});